import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=d15e9514&scoped=true&"
import script from "./ReservationDetails.vue?vue&type=script&lang=js&"
export * from "./ReservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=d15e9514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15e9514",
  null
  
)

export default component.exports